// @ts-nocheck
import { Timer } from "./Timer";
import { application } from "./WebApp.Instance";
import { PopUp } from "./WebApp.PopUp.Anchored";
import { ClickOutsideListener, removeClickOutsideListener } from "./WebSite.Page.Component";

export class Old_PopUp {
  constructor(element, parent, restore, trigger = null, delay = 0) {
    this.element = element;
    this.parent = parent;
    this.popup = null;
    this.restore = restore;
    this.trigger = trigger;
    this.delay = delay;
    this.openTimer = new Timer(delay);
    this.closeTimer = new Timer(delay);
  }

  open(anchorLeft = null) {
    this.closeTimer.kill();

    if (this.delay > 0) {
      this.openTimer.kill();
      this.openTimer.schedule(() => { this.show(anchorLeft); });
    }
    else
      this.show(anchorLeft);
  }

  close() {
    this.openTimer.kill();

    if (this.delay > 0) {
      this.closeTimer.kill();
      this.closeTimer.schedule(() => { this.hide(); });
    }
    else
      this.hide();
  }

  show(anchorLeft = null) {
    if (!this.isOpen()) {
      const target = application.pageHandler.contents.element;
      const viewPort = target.getBoundingClientRect();
      const bounds = this.parent.getBoundingClientRect();

      this.popup = document.createElement("div");
      this.popup.classList.add("PopUp");
      this.popup.instance = this;
      this.popup.appendChild(this.element);
      this.popup.style.position = "absolute";
      this.popup.style.top = (target.scrollTop + bounds.bottom - viewPort.top) + "px";
      this.popup.style.left = (target.scrollLeft + bounds.left - viewPort.left) + "px";
      this.popup.style.zIndex = "var(--z-index-pop-up)";

      target.appendChild(this.popup);

      if (bounds.bottom + this.popup.offsetHeight > window.innerHeight && bounds.top - this.popup.offsetHeight >= viewPort.top)
        this.popup.style.top = (target.scrollTop + bounds.top - viewPort.top - this.popup.offsetHeight) + "px";

      if (anchorLeft !== null) {
        let left = Math.min(anchorLeft, bounds.right - this.popup.offsetWidth, window.innerWidth - this.popup.offsetWidth);
        left = Math.max(left, bounds.left);

        this.popup.style.left = (target.scrollLeft + left - viewPort.left) + "px";
      }

      if (this.delay > 0) {
        this.popup.addEventListener("mouseenter", (event) => { this.closeTimer.kill(); });
        this.popup.addEventListener("mouseleave", (event) => { this.close(); });
      }

      this.popup.addEventListener(
        "keydown",
        (event) => {
          if (event.code === "Escape")
            this.close();
        }
      );

      this.outsideListener = new ClickOutsideListener(
        this.trigger ? [this.popup, this.trigger] : [this.popup],
        (event) => {
          this.close();
        }
      );
    }
  }

  hide() {
    if (this.isOpen()) {
      this.closePopUpsOnTop();

      if (this.restore)
        this.parent.appendChild(this.element);

      application.pageHandler.contents.element.removeChild(this.popup);
      removeClickOutsideListener(this.outsideListener);

      this.popup = null;
    }
  }

  closePopUpsOnTop() {
    const popUps = application.pageHandler.getPopUps();

    for (let index = popUps.length - 1; popUps[index] !== this.popup; index--)
      popUps[index].instance.close();
  }

  isOpen() {
    return this.popup !== null;
  }
}

export function createPopUp(element, parent, restore, trigger = null, delay = 0, anchorElement = null) {
  const supportsAnchorPositioning = CSS.supports("anchor-name", "--pop-up") && CSS.supports("top", "anchor(bottom)");

  return supportsAnchorPositioning
    ? new PopUp(element, parent, restore, trigger, delay, anchorElement)
    : new Old_PopUp(element, parent, restore, trigger, delay);
}
